module.exports = __webpack_public_path__ + "static/media/tooltip.5fd29fae.svg";